import { request } from "./common";

const API_URL = `${process.env.API_URL || ""}`;

/**
 * Helper method to upload user resume
 * @param data
 * @param options
 * @returns {Promise<AxiosResponse<any>>}
 */
export function sendEmail(data, options = {}) {
  //alert(data);
  // Update the URL as per the API
  return request(`${API_URL}/email/send`, {
    method: "POST",
    data,
    ...options,
  });
}
